import React from 'react';
import { StarIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { avatarColors } from '../data/coaches';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  subtitle = 'From volunteer, parent and club coaches running U8–U14 teams.',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-navy' : 'bg-navy-mid';
  return <section aria-label={title} className={`w-full text-white ${bg}`} data-id="element-298" data-mp="2x1l2t0ztn40x">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-299" data-mp="2s2i5y3tzw441">
        <div className="text-center" data-id="element-300" data-mp="2s430vuk81p2f">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-gold" data-id="element-301" data-mp="v9oq3o1x3o4k">Coach to coach</p>
          <h2 className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-302" data-mp="qbesz7wmudgb">{title}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-303" data-mp="h559pzvzjrw1">{subtitle}</p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-304" data-mp="m5syeewqrwn3">
          {testimonials.map((item, i) => <figure key={i} className="rounded-2xl border border-navy-line bg-navy-card p-5 shadow-card" data-id="element-305" data-mp="79lezgt5qz8v" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-306" data-mp="c73nj639jcgc">
                <Avatar name={item.author} src={item.avatar} color={avatarColors[i % avatarColors.length]} className="h-11 w-11" data-id="element-307" data-mp="zw68onx3vnfl" />
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-308" data-mp="q5uyijmtwi09">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-309" data-mp="v3mvhs2byubb" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm text-white/90" data-id="element-310" data-mp="1nmsf6argoznh">{item.quote}</blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-311" data-mp="1xgxzxcbaibnh">
                <span className="block text-[13px] font-semibold text-white" data-id="element-312" data-mp="1sj5vxjxdez2x">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}